export const pretty = (s: string) => {
  s = s.replace(/([A-Z])/g, ' $1');
  return s[0].toUpperCase() + s.slice(1);
};

export const cutoffsMap = {
  sorted: 'sortedAt',
  inTransit: 'firstCarrierScanAt',
  outForDelivery: 'firstOutForDeliveryAt',
  completed: 'completedAt',
};

export const Cutoffs = ['sortedAt', 'firstCarrierScanAt', 'firstOutForDeliveryAt', 'completedAt'] as const;
export type Cutoff = (typeof Cutoffs)[number];

export const getDefault = (cutoff: Cutoff, type: 'hours' | 'minutes' | 'days'): number =>
  ({
    sortedAt: { hours: 10, days: 1 },
    firstCarrierScanAt: { hours: 8 },
    firstOutForDeliveryAt: { hours: 14 },
    completedAt: { hours: 22 },
  })[cutoff]?.[type] || 0;

export const defaultCutoffTimes = {
  sortedAtCutoffHours: 10,
  sortedAtCutoffMinutes: 0,
  sortedAtDaysDiff: 1,
  firstCarrierScanAtCutoffHours: 10,
  firstCarrierScanAtCutoffMinutes: 0,
  firstCarrierScanAtDaysDiff: 0,
  firstOutForDeliveryAtCutoffHours: 15,
  firstOutForDeliveryAtCutoffMinutes: 0,
  firstOutForDeliveryAtDaysDiff: 0,
  completedAtCutoffHours: 22,
  completedAtCutoffMinutes: 0,
  completedAtDaysDiff: 0,
};
